import { createAction, props } from '@ngrx/store';

export enum UsersActions {
  UsersRequested = '[Users] Users Requested',
  UsersLoaded = '[Users] Users Loaded',
  UsersError = '[Users] Users Error',
  LoggedUserRequested = '[Users] Logged User Requested',
  LoggedUserLoaded = '[Users] Logged User Loaded',
  LoggedUserError = '[Users] Logged User Error',
  UsersForClientFilterRequested = '[Users] Users For Client Filter Requested',
  UsersForClientFilterLoaded = '[Users] Users For Client Filter Loaded',
  UsersForClientFilterError = '[Users] Users For Client Filter Error',
}

export const UsersRequested = createAction(UsersActions.UsersRequested);
export const UsersLoaded = createAction(UsersActions.UsersLoaded,
  props<{ users: [] }>());
export const UsersError = createAction(UsersActions.UsersError);

export const LoggedUserRequested = createAction(UsersActions.LoggedUserRequested,
  props<{ userId: string }>());
export const LoggedUserLoaded = createAction(UsersActions.LoggedUserLoaded,
  props<{ loggedUser: any }>());
export const LoggedUserError = createAction(UsersActions.LoggedUserError);

export const UsersForClientFilterRequested = createAction(UsersActions.UsersForClientFilterRequested);
export const UsersForClientFilterLoaded = createAction(UsersActions.UsersForClientFilterLoaded, props<{ usersForClientFilter: [] }>()); 
export const UsersForClientFilterError = createAction(UsersActions.UsersForClientFilterError);
